import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";

export const ExceedsNonPrimaryVolumeStatisticsSnapshotEntryValidator = t.intersection([
  t.type({
    dttm: t.number,
    count: t.number,
    volume: t.number,
  }),
  t.partial({}),
]);

export const ExceedsNonPrimaryVolumeStatisticsSnapshotEntryArrayValidator = t.array(ExceedsNonPrimaryVolumeStatisticsSnapshotEntryValidator);

export type ExceedsNonPrimaryVolumeStatisticsSnapshotEntrySnapshotEntry = t.TypeOf<typeof ExceedsNonPrimaryVolumeStatisticsSnapshotEntryValidator>;
export type ExceedsNonPrimaryVolumeStatisticsSnapshotEntryArray = t.TypeOf<typeof ExceedsNonPrimaryVolumeStatisticsSnapshotEntryArrayValidator>;

@Exclude()
export class ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity {
  @Expose()
  dttm!: number

  @Expose()
  count!: number

  @Expose()
  volume!: number

  /**
   * Constructor for ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerExceedsNonPrimaryVolumeStatisticsSnapshotEntry: ExceedsNonPrimaryVolumeStatisticsSnapshotEntrySnapshotEntry): ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity {
    return plainToInstance(
      ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity,
      containerExceedsNonPrimaryVolumeStatisticsSnapshotEntry,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  loadTypeValue(): Promise<ExceedsNonPrimaryVolumeStatisticsSnapshotEntrySnapshotEntry> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ExceedsNonPrimaryVolumeStatisticsSnapshotEntryValidator, object);
  }

  asTypeValue(): ExceedsNonPrimaryVolumeStatisticsSnapshotEntrySnapshotEntry {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ExceedsNonPrimaryVolumeStatisticsSnapshotEntryValidator, object);
  }
}
